import React, {Dispatch} from 'react';
import * as Body from './Styles'

type Props = {
    text: string,
    width?: number,
    action?: any,
    bg?: string,
    bordercolor?: string,
    disabled?: boolean,
    loading?: boolean
}

const Button: React.FC <Props> = ({
    text, width, action, bg, bordercolor,disabled, loading
}) => {
    return <Body.Button style={{width: width? width:'', backgroundColor: bg? bg:'',
        borderColor: bordercolor?bordercolor:''}} onClick={action} disabled={disabled || loading} >
        {loading ? <Body.LoadingDots><span/><span/><span/></Body.LoadingDots> : text}
    </Body.Button>
}

export default Button